import { createFileRoute } from "@tanstack/react-router";

import { LimitsHubPage } from "@/components/marketing/limits-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/limits/")({
  head: () => pageHead("limits"),
  component: LimitsHubPage,
});
